@if (isLoading) {
  <div class="overlay">
    <!-- <div>This is the loader</div> -->
    <div class="loader"></div>
  </div>
}